<app-fullscreen-dialog-layout [showCloseButton]="true" (dismissed)="dismiss()">
    <div left [translate]="'CLOSE'" i18n="@@CLOSE">Close</div>
    <div title [translate]="'SPEECH_TO_SCORE'" i18n="@@SPEECH_TO_SCORE">Speech to score</div>

    <div class="flex flex-1 flex-col overflow-hidden">
        <div class="flex flex-none items-center justify-between gap-4 px-4 py-4">
            <div>
                <span [translate]="'SPEECH_TO_SCORE_INFO'" i18n="@@SPEECH_TO_SCORE_INFO">
                    Use speech to score to control the app
                </span>
            </div>
            <button
                type="button"
                dcToggleSwitch
                [checked]="preferenceService.enableSpeechToScore()"
                (switchChange)="toggleSpeechToScore()"></button>
        </div>

        <div class="flex flex-1 flex-col gap-4 overflow-y-auto px-4 pb-6">
            @for (info of speechToScoreService.commandInfo(); track $index) {
                <div
                    class="rounded-xl transition-all duration-200"
                    [class.opacity-40]="editableType() && editableType() !== info.type"
                    dcBgColor="wire-white">
                    <div class="px-4 py-3">
                        <div dcTypography="geist-14-semibold">{{ info.title }}</div>
                    </div>

                    <div
                        class="flex w-full items-center justify-center px-4 pb-4"
                        [class.editing]="editableType() && editableType() !== info.type">
                        <div class="w-full rounded-xl px-4 py-3" dcBgColor="light-flight-blue-gradient">
                            <div class="text-container flex gap-2">
                                @for (list of info.list; track $index) {
                                    @if (list.option === speechToScoreService.commandOptions()[info.type]) {
                                        @for (text of list.parts[0].texts; track $index) {
                                            <div class="text-fragment">
                                                @switch (text.type) {
                                                    @case ('command') {
                                                        <div dcTypography="geist-14-semibold">"{{ text.text }}"</div>
                                                    }
                                                    @case ('input') {
                                                        <div dcTypography="geist-14" class="italic">
                                                            {{ text.text }}
                                                        </div>
                                                    }
                                                    @case ('text') {
                                                        <div dcTypography="geist-14">{{ text.text }}</div>
                                                    }
                                                    @case ('lang') {
                                                        <div
                                                            class="lang-type flex items-center gap-2"
                                                            dcTypography="geist-14">
                                                            <img
                                                                class="h-4 w-[1.6875rem]"
                                                                src="{{ text.data | countryFlag }}" />
                                                            <span>{{ text.text }}</span>
                                                        </div>
                                                    }
                                                }
                                            </div>
                                        }
                                    }
                                }
                            </div>
                        </div>

                        @if (info.hasOptions) {
                            <button
                                type="button"
                                class="flex items-center justify-center px-2"
                                (click)="changeType(info.type)">
                                <app-icon
                                    [icon]="editableType() ? 'keyboard_arrow_up' : 'keyboard_arrow_down'"
                                    dcColor="oche-orange"></app-icon>
                            </button>
                        }
                    </div>

                    @if (editableType() === info.type) {
                        <div class="z10 relative px-4 pb-4">
                            <div class="list-container absolute left-0 right-0 top-0 rounded-xl">
                                <div
                                    class="command-container rounded-xl px-4 py-3"
                                    dcBgColor="wire-white"
                                    dcBorderColor="flight-blue-2">
                                    <div class="flex flex-col gap-2">
                                        @for (list of info.list; track $index) {
                                            @if (list.option !== speechToScoreService.commandOptions()[info.type]) {
                                                <button
                                                    type="button"
                                                    class="w-full text-left"
                                                    (click)="changeOption(list.option)">
                                                    <div class="text-container flex flex-wrap items-center gap-2 py-2">
                                                        @for (text of list.parts[0].texts; track $index) {
                                                            <div class="text-fragment">
                                                                @switch (text.type) {
                                                                    @case ('command') {
                                                                        <span dcTypography="geist-14-semibold"
                                                                            >"{{ text.text }}"</span
                                                                        >
                                                                    }
                                                                    @case ('input') {
                                                                        <span dcTypography="geist-14" class="italic">
                                                                            {{ text.text }}
                                                                        </span>
                                                                    }
                                                                    @case ('text') {
                                                                        <span dcTypography="geist-14">{{
                                                                            text.text
                                                                        }}</span>
                                                                    }
                                                                    @case ('lang') {
                                                                        <span
                                                                            class="lang-type inline-flex items-center gap-2"
                                                                            dcTypography="geist-14">
                                                                            <img
                                                                                class="h-4 w-[1.6875rem]"
                                                                                src="{{ text.data | countryFlag }}" />
                                                                            <span>{{ text.text }}</span>
                                                                        </span>
                                                                    }
                                                                }
                                                            </div>
                                                        }
                                                    </div>
                                                </button>
                                            }
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
                </div>
            }
        </div>
    </div>
</app-fullscreen-dialog-layout>
